import { all } from "redux-saga/effects"

import { reportWatchers } from './report-watchers'


export default function* rootSaga() {
    const watchers = [...reportWatchers]
    yield all(watchers)
}